export class Links {
  constructor() {
    this._elem = document.querySelector('.popular-link');
    if (this._elem === null) {
      return;
    }
    this._list = this._elem.querySelector('.popular-link__list');
    this._moreButton = this._elem.querySelector('.popular-link__button');
    this._searchButton = this._elem.querySelector('.popular-link__item--search');
    this.callback = {};

    this._moreButtonClickHandler = this._moreButtonClickHandler.bind(this);
    this._searchButtonClickHandler = this._searchButtonClickHandler.bind(this);

    if (this._moreButton) {
      this._moreButton.addEventListener('click', this._moreButtonClickHandler);
    }
  }

  isExist() {
    return this._elem !== null;
  }

  _moreButtonClickHandler() {
    this._list.classList.remove('popular-link__list--short');
    this._moreButton.remove();
    this._moreButton = null;
  }

  _searchButtonClickHandler(evt) {
    evt.preventDefault();
    this.callback.click(evt);
  }

  setSearchButtonClickHandler(callback) {
    this.callback.click = callback;
    if (this._searchButton) {
      this._searchButton.addEventListener('click', this._searchButtonClickHandler);
    }
  }
}
